import mapSceneToComponent from '../mapSceneToComponent.js'
import script from './scientificDetective.json'
import { factoryAlley, factoryStreet, pakNSave, tip } from '../locations.js'

export const Scene = (scene) => () => {
  return (
    <>
      {scene.map(mapSceneToComponent)}
    </>
  )
}

const scenes = script.scenes

// Generated from Scientific_Detective_message_and_map_v6.docx (script_stuff/POSTGRAD game files) by the
// script-to-stories skill. Location names in the v6 docx are canonical; each
// path maps 'Theater' to its own factory* constant so markers from parallel
// paths don't stack. 'DIRECT' / 'NONE' entries are null.
// Conversation `from` uses the game's contact name "Arthur"; marker/teaser
// text keeps the docx's "Pop" (Bel's name for him).
const conversations = [
  {
    from: 'Arthur',
    messages: [
      { text: 'I have a project I need to keep from your grandmother. Please do call me when you have a chance.', isFromMe: false }
    ]
  },
  {
    from: 'Arthur',
    messages: [
      { text: 'Good morning Bel. When shall I come by?', isFromMe: false }
    ]
  },
  {
    from: 'Arthur',
    messages: [
      { text: 'Hello Bel, we don\'t have too long to make a decision. Do let me know.', isFromMe: false },
      { text: 'I have a counter offer. Can you come over to the theater in the evening, like 8:00?', isFromMe: true },
      { text: 'Yes, Betty will just be watching her shows. Let me know which evening.', isFromMe: false }
    ]
  },
  {
    from: 'Arthur',
    messages: [
      { text: 'Hello Bel, When would you be available to pick up the specimens? The refuse station closes at 5:30pm on week days.', isFromMe: false },
      { text: 'I will figure out what Junior is up to then give you a call. I can pick you up.', isFromMe: true }
    ]
  },
  null, // DIRECT
  {
    from: 'Arthur',
    messages: [
      { text: 'The wardrobe and stuff in your garage, can we use that as props to hide the lab?', isFromMe: true },
      { text: 'Yes we can use the furniture, shall we take it over in the van?', isFromMe: false },
      { text: 'Yeah, easy. I\'ll call you when I\'m free', isFromMe: true }
    ]
  },
  {
    from: 'Arthur',
    messages: [
      { text: 'When shall I come by?', isFromMe: false },
      { text: 'I\'ll call you. I should be free soon.', isFromMe: true }
    ]
  },
  {
    from: 'Arthur',
    messages: [
      { text: 'May I visit later. I need to discuss something.', isFromMe: false },
      { text: 'I think so, but I\'ll call you soon.', isFromMe: true }
    ]
  },
  null, // DIRECT
  {
    from: 'Arthur',
    messages: [
      { text: 'Answer your phone Bel, or I\'ll have to call the work number. This is urgent.', isFromMe: false }
    ]
  },
  null // DIRECT
]

const markers = [
  { location: pakNSave, text: 'Call Pop back' }, // docx loc: 'Supermarket car park'
  { location: factoryStreet, text: 'Meet Pop out front' }, // docx loc: 'Theater'; docx note: the street in front of the theater
  { location: factoryAlley, text: 'Meet Pop about counter offer.' }, // docx loc: 'Theater'
  { location: tip, text: 'Pick up cats.' }, // docx loc: 'Refuse station'
  null, // DIRECT
  { location: factoryAlley, text: 'Hide the cat lab' }, // docx loc: 'Theater'
  { location: factoryAlley, text: 'See if the cat has thawed yet.' }, // docx loc: 'Theater'
  { location: factoryAlley, text: 'Defrost a cat.' }, // docx loc: 'Theater'
  null, // DIRECT
  { location: factoryAlley, text: 'Pop calls' }, // docx loc: 'Theater'
  null // DIRECT
]

const teasers = [
  'Did Pop say frozen cats?',
  'Dead cats in a food grade lab?',
  'Pick up freezer full of cats?',
  null, // DIRECT
  'How to hide the lab in the container?',
  'How long does a cat take to thaw?',
  'What will vets say about the frozen cats?',
  null, // DIRECT
  'The cats relate to the metademic?',
  null, // DIRECT
  'END of Chapter One.'
]


const art = [
  { url: '/scientific_detective/scene1.jpg' },
  { url: '/scientific_detective/scene2.jpg' },
  { url: '/scientific_detective/scene3.jpg' },
  { url: '/scientific_detective/scene4.jpg' },
  { url: '/scientific_detective/scene5.jpg' },
  { url: '/scientific_detective/scene6.jpg' },
  { url: '/scientific_detective/scene7.jpg' },
  { url: '/scientific_detective/scene8.jpg' },
  { url: '/scientific_detective/scene9.jpg' },
  { url: '/scientific_detective/scene10.jpg' },
  { url: '/scientific_detective/scene11.jpg' }
]

// AUTO-GENERATED by scripts/deriveTimesOfDay.js — do not hand-edit; rerun `npm run derive-times-of-day` instead.
// Derived from each scene's opening SceneHeading in scientificDetective.json.
// (DAY -> afternoon, MORNING -> morning, EVENING -> evening, NIGHT -> evening;
// a CONTINUOUS/LATER opening heading inherits the previous scene's slot.)
const timesOfDay = [
  'evening', // 0: INT. VAN - NIGHT
  'morning', // 1: EXT. STREET IN FRONT OF THEATER - MORNING
  'evening', // 2: EXT. ALLEY BEHIND THEATER - EVENING
  'evening', // 3: EXT. IN FRONT OF A SHED, BESIDE A RUN-DOWN BUILDING - EARLY EVENING
  'evening', // 4: INT. THE SHIPPING CONTAINER - LATER THAT NIGHT
  'evening', // 5: INT. THE SHIPPING CONTAINER - CONTINUOUS (inherited)
  'evening', // 6: EXT. IN FRONT OF CONTAINER - NIGHT
  'evening', // 7: EXT. IN FRONT OF CONTAINER - LATER (inherited)
  'evening', // 8:  (inherited)
  'morning', // 9: INT. LOBBY - AT TICKET COUNTER - MORNING
  'morning', // 10:  (inherited)
]

const stories = scenes.map((scene, i) => ({
  timeOfDay: timesOfDay[i],
  sceneArt: art[i],
  scene,
  conversation: conversations[i] || undefined,
  marker: markers[i] || undefined,
  teaser: teasers[i] || undefined
}))

export default stories
